import { ca } from '@cian/analytics';
import { TViewMode } from './ProjectsOnMap';

export function trackShowProjectsMap() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'CardBuilder',
    action: 'show_map',
    useLastProducts: true,
  });
}

export function trackMapFilterClick(mode: TViewMode) {
  const mapper: Record<TViewMode, string> = {
    newBuildings: 'JK',
    offices: 'sales_office',
  };

  ca('eventSite', {
    name: 'oldevent',
    category: 'CardBuilder',
    action: 'click_map_filter',
    label: mapper[mode],
    useLastProducts: true,
  });
}
